<body class="flex flex-col min-h-screen">
  <nav class="p-4">
    <div class="container mx-auto flex justify-between items-center">
      <a [routerLink]="['/']" routerLinkActive="router-link-active">
        <img src="assets/images/cat_logo.png" alt="Company Logo" class="h-14" />
      </a>
      <div>
        @if (!userLoggedIn) {
        <a
          [routerLink]="['/auth']"
          class="text-white bg-red-600 py-2 px-4 rounded-lg font-semibold hover:bg-red-700 focus:ring-4 focus:ring-red-600 focus:ring-opacity-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Login </a
        >}
      </div>
    </div>
  </nav>

  <main class="flex-grow container mx-auto p-4">
    <router-outlet></router-outlet>
  </main>

  <footer class="p-4">
    <div class="container mx-auto text-center text-gray-500">
      &copy; {{ year }} Caribbean Auto Terminal. All rights reserved.
    </div>
  </footer>
</body>
